<template>
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
  >
    <path d="M0.739665 0.200408C0.436132 0.48226 0.418556 0.956809 0.700408 1.26034L4.22652 5L0.700408 8.73967C0.418556 9.0432 0.436132 9.51775 0.739665 9.7996C1.0432 10.0815 1.51775 10.0639 1.7996 9.76034L5.7996 5.51034C6.0668 5.22258 6.0668 4.77743 5.7996 4.48966L1.7996 0.239665C1.51775 -0.0638681 1.0432 -0.081444 0.739665 0.200408Z" />
  </svg>
</template>
